import { render, staticRenderFns } from "./TheaterAccreditationListContainer.vue?vue&type=template&id=a70b596a&scoped=true"
import script from "./TheaterAccreditationListContainer.vue?vue&type=script&lang=js"
export * from "./TheaterAccreditationListContainer.vue?vue&type=script&lang=js"
import style0 from "./TheaterAccreditationListContainer.vue?vue&type=style&index=0&id=a70b596a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70b596a",
  null
  
)

export default component.exports